module.exports = __webpack_public_path__ + "images/headergradiente627bfa48c67f72f699b8a0e018f52e8.png";